/** * Created by lobin on 2019/4/1. */
<template>
  <div class="flexColumn">
    <img style="width: 70%;"  :src="img"   />
  </div>
</template>

<script type="text/babel">
import {getSystemImage} from '@/api/common'
export default {
  data() {
    return {
        img: ''
    };
  },
  async created(){
    try{
      const data = await getSystemImage(30);
      this.img = data;
    }
    catch(e){
        console.error('获取图片出错',e);
    }
  }
};
</script>
 
<style lang="less" rel="stylesheet/less" scoped>

</style>
